import { BarChartData } from '../..';
import { BarDatum, ResponsiveBar } from '@nivo/bar';

import { theme } from '../../theme-dashboard';
import { NoData } from '../no-data';
import { Tooltip } from './components/tooltip';

export const BarChart = ({
  data = [],
  sortByValue = true,
}: {
  data: BarChartData;
  sortByValue?: boolean;
}) => {
  let sortedData = data;

  if (sortByValue) {
    sortedData = [...data].sort((a, b) => a.value - b.value);
  }

  if (sortedData.length === 0) {
    return <NoData />;
  }

  return (
    <ResponsiveBar
      data={sortedData as unknown as BarDatum[]}
      theme={theme}
      keys={['value']}
      indexBy="category"
      margin={{ top: 32, right: 32, bottom: 32, left: 88 }}
      padding={0.25}
      innerPadding={1}
      layout="horizontal"
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={{ scheme: 'category10' }}
      borderRadius={4}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: -40,
        truncateTickAt: 10,
      }}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={theme.textColor}
      tooltip={Tooltip}
    />
  );
};